// Pure helpers that turn a failed request into a localized, truthful message key.
export function classifyError(error) {
  if (typeof error === 'string') return error
  const response = error && error.response
  // A request that got no response may still have been applied by the server.
  if (!response) return 'foundation.errors.network'
  const { status } = response
  if (status === 401) return 'foundation.errors.session'
  if (status === 403) return 'foundation.errors.forbidden'
  if (status === 404) return 'foundation.errors.notFound'
  if (status === 409 || status === 412) return 'foundation.errors.conflict'
  if (status === 400 || status === 422) return 'foundation.errors.validation'
  if (status >= 500) return 'foundation.errors.server'
  return 'foundation.errors.generic'
}

// A refused list request needs a permission message; every other failure may succeed on retry.
export function loadErrorKind(error) {
  return error && error.response && error.response.status === 403 ? 'forbidden' : 'error'
}

export function isUnknownResult(error) {
  return Boolean(error) && typeof error === 'object' && !error.response
}

// Runs one operation at a time per guard so double clicks cannot repeat a write.
export function createSingleFlight() {
  let running = false
  return async task => {
    if (running) return { skipped: true }
    running = true
    try {
      return { skipped: false, value: await task() }
    } finally {
      running = false
    }
  }
}
